import { render, staticRenderFns } from "./releaseDemand.vue?vue&type=template&id=50577b4e&scoped=true&"
import script from "./releaseDemand.vue?vue&type=script&lang=js&"
export * from "./releaseDemand.vue?vue&type=script&lang=js&"
import style0 from "./releaseDemand.vue?vue&type=style&index=0&id=50577b4e&prod&lang=less&scoped=true&"
import style1 from "./releaseDemand.vue?vue&type=style&index=1&id=50577b4e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50577b4e",
  null
  
)

export default component.exports